import Drag from "./src/index.vue";
import type { App } from "vue";
Drag.install = function (Vue: App): void {
  console.info("Drag----install----");
  Vue.component(Drag.name, Drag);
};

export default Drag;
